import axios from 'axios';
import properties from '../../core-utils/properties';
import messages from '../../core-utils/messages';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import { roundNumber } from '../../core-utils/helper-utils/helper';

export const getMedicationAdherence = async (
  requestParams: any,
  setMedicationAdherence: any,
  handleOpenSnackBar?: any,
) => {
  const url =
    properties.aiqBaseUrl +
    properties.membersBaseUrl +
    properties.medicationAdherence;

  await axios
    .post(url, requestParams)
    .then((response) => {
      if (response?.status === 200) {
        const adherence_ratio = response.data?.data;

        const table: any[] = [];
        if (Array.isArray(adherence_ratio)) {
          adherence_ratio?.forEach(async (item: any) => {
            const condition: any = [];
            condition.push(getTextWithToolTip(item.drug_name, 20));
            condition.push(roundNumber(item.ratio, 3));
            // condition.push(item?.year);
            table.push(condition);
          });
        }
        setMedicationAdherence(table);
      }
    })
    .catch((error) => {
      handleOpenSnackBar(
        error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
        'error',
        8000,
      );
    });
};
